import PicabooConstants, {
  DEFAULT_TRADEBOOK_PAGE_COUNT,
} from '../common/PicabooConstants';
import logEvent from '../utils/TagManager';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import { fork, put, select, takeLatest } from 'redux-saga/effects';
import * as Selectors from '../reducers/selectors';
import {
  getCurrentLayouts,
  getSavedLayouts,
  SUPPORTS_LAYOUTS,
} from './layouts';
import { canNavigate } from '../utils/navigationUtil';
import { isMobile } from '../components/PicabooResponsive';
import { selectPageItems } from './selection';
import { PAGE_ITEM_SELECTION } from '../actions';
import { showSuccessModal } from './modals';
import { updateUserPreference } from './user';
import { isList } from 'immutable';

const SET_SELECTED_TAB = 'SET_SELECTED_TAB';
const CLEAR_SELECTED_TAB = 'CLEAR_SELECTED_TAB';
const SET_ZOOM_LEVEL = 'SET_ZOOM_LEVEL';
export const TAB_EDIT_PHOTO = 'TAB_EDIT_PHOTO';
export const TAB_EDIT_RICH_TEXT = 'TAB_EDIT_RICH_TEXT';
export const TAB_BACKGROUND = 'TAB_BACKGROUND';
export const TAB_LAYOUTS = 'TAB_LAYOUTS';
export const TAB_COVER_DESIGN = 'TAB_COVER_DESIGN';
export const TAB_BOOK_STYLE = 'TAB_BOOK_STYLE';
export const TAB_DESIGNER = 'TAB_DESIGNER';
export const TAB_DESIGNS = 'TAB_DESIGNS';
export const TAB_WARNINGS = 'TAB_WARNINGS';
export const TAB_FRAME_COLOR = 'TAB_FRAME_COLOR';
const SET_BOTTOM_TAB = 'SET_BOTTOM_TAB';
export const TAB_PHOTOS = 'TAB_PHOTOS';
export const TAB_PAGES = 'TAB_PAGES';
export const TAB_GALLERIES = 'TAB_GALLERIES';
export const TAB_OPTIONS = 'TAB_OPTIONS';
export const TAB_SETTINGS = 'TAB_SETTINGS';
export const TAB_PROJECTS = 'TAB_PROJECTS';
export const TAB_HELP = 'TAB_HELP';
export const TAB_LOGOUT = 'TAB_LOGOUT';

const TOGGLE_PHOTOS_MODAL = 'TOGGLE_PHOTOS_MODAL';
const TOGGLE_MOBILE_PHOTOS_UPLOAD = 'TOGGLE_MOBILE_PHOTOS_UPLOAD';
const TOGGLE_PHOTO_VIEW_MODAL = 'TOGGLE_PHOTO_VIEW_MODAL';
const TOGGLE_AUTO_FILL_PROMPT_MODAL = 'TOGGLE_AUTO_FILL_PROMPT_MODAL';
const CLOSE_AUTO_FILL_PROMPT_MODAL = 'CLOSE_AUTO_FILL_PROMPT_MODAL';
const TOGGLE_AUTO_FILL_WAIT_MODAL = 'TOGGLE_AUTO_FILL_WAIT_MODAL';
const SET_EDITOR_DIM = 'SET_EDITOR_DIM';
const RENDER_CANVAS_FROM_STORE = 'RENDER_CANVAS_FROM_STORE';
const SET_SIDEPANEL_OPENED = 'SET_SIDEPANEL_OPENED';
const SET_VIEWPRINTS_FORCE_CLOSED = 'SET_VIEWPRINTS_FORCE_CLOSED';
const SET_BOTTOMPANEL_OPENED = 'SET_BOTTOMPANEL_OPENED';
const SET_BOTTOMPANEL_EXPANDED = 'SET_BOTTOMPANEL_EXPANDED';
const SET_CAN_NAVIGATE = 'SET_CAN_NAVIGATE';
const SET_IS_RESIZING = 'SET_IS_RESIZING';
const ENTER_SHARE_VIEW = 'ENTER_SHARE_VIEW';
const ENTER_EDITINGVIEW_MODE = 'ENTER_EDITINGVIEW_MODE';
const EXIT_EDITINGVIEW_MODE = 'EXIT_EDITINGVIEW_MODE';
const ENTER_PREVIEW_MODE = 'ENTER_PREVIEW_MODE';
const EXIT_PREVIEW_MODE = 'EXIT_PREVIEW_MODE';
const ENTER_GRID_VIEW = 'ENTER_GRID_VIEW';
const EXIT_GRID_VIEW = 'EXIT_GRID_VIEW';
const SET_NAVIGATION = 'SET_NAVIGATION';
const SWITCH_PRINTS_VIEW = 'SWITCH_PRINTS_VIEW';
const TOGGLE_IMAGE_MANAGMENT = 'TOGGLE_IMAGE_MANAGMENT';
const CLEAR_IMAGE_MANAGEMENT_POST_ACTION = 'CLEAR_IMAGE_MANAGEMENT_POST_ACTION';
const SET_LEFT_PAGE_ZOOM = 'SET_LEFT_PAGE_ZOOM';
const COLOR_PICKER_OPEN = 'COLOR_PICKER_OPEN';

export const SET_MOBILE = 'SET_MOBILE';

const initialState = {
  editorTab: TAB_PHOTOS,
  showPhotosModal: false,
  showPhotosUploadingScreen: false,
  showPhotoViewModal: false,
  showAutoFillPromptModal: false,
  isAutoPopulate: false,
  showAutoFillWaitModal: false,
  zoomLevel: PicabooConstants.ZOOM_LEVEL.FIT_PAGE,
  zoomPageLeft: true,
  editorDim: {},
  renderCanvas: new Date().getTime(),
  renderPage: null,
  sidePanelOpened: true,
  colorPickerIsOpen: false,
  viewPrintsForceClosed: false,
  bottomPanelOpened: true,
  bottomPanelExpanded: false,
  viewport: window.innerWidth,
  canGoForward: false,
  canGoBack: false,
  forwardLocked: false,
  backLocked: false,
  isResizing: false,
  shareView: false,
  previewMode: false,
  editingView: true,
  gridView: false,
  modalAutoOpened: false,
  previewMode3D: false,
  showImageManagement: false,
  isMobile: isMobile(),
  showImageManagementPostAction: null,
};

/**
 *  reducers
 */

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MOBILE: {
      return { ...state, isMobile: action.isMobile };
    }
    case SET_LEFT_PAGE_ZOOM: {
      return { ...state, zoomPageLeft: action.value };
    }
    case SET_SELECTED_TAB: {
      return { ...state, editorTab: action.selectedTab, sidePanelOpened: true };
    }
    case CLEAR_SELECTED_TAB: {
      return { ...state, editorTab: null, sidePanelOpened: false };
    }
    case SET_BOTTOM_TAB: {
      return { ...state, bottomBarTab: action.selectedTab };
    }
    case TOGGLE_PHOTOS_MODAL: {
      return {
        ...state,
        showPhotosModal: !state.showPhotosModal,
        modalAutoOpened: action.modalAutoOpened,
      };
    }
    case TOGGLE_MOBILE_PHOTOS_UPLOAD: {
      return {
        ...state,
        showPhotosUploadingScreen: !state.showPhotosUploadingScreen,
      };
    }
    case TOGGLE_PHOTO_VIEW_MODAL: {
      return {
        ...state,
        showPhotoViewModal: !state.showPhotoViewModal,
        modalPhotoViewOpened: action.modalPhotoViewOpened,
      };
    }
    case TOGGLE_IMAGE_MANAGMENT: {
      return {
        ...state,
        showImageManagement: !state.showImageManagement,
        pickPhoto: action.pickPhoto,
        showImageManagementPostAction: action.postAction
          ? action.postAction
          : state.showImageManagementPostAction,
      };
    }
    case CLEAR_IMAGE_MANAGEMENT_POST_ACTION: {
      return { ...state, showImageManagementPostAction: null };
    }
    case TOGGLE_AUTO_FILL_PROMPT_MODAL: {
      return {
        ...state,
        showAutoFillPromptModal: !state.showAutoFillPromptModal,
        isAutoPopulate: action.isAutoPopulate,
      };
    }
    case CLOSE_AUTO_FILL_PROMPT_MODAL: {
      return {
        ...state,
        showAutoFillPromptModal: false,
      };
    }
    case TOGGLE_AUTO_FILL_WAIT_MODAL: {
      return { ...state, showAutoFillWaitModal: !state.showAutoFillWaitModal };
    }
    case SET_ZOOM_LEVEL: {
      return { ...state, zoomLevel: action.zoomLevel };
    }
    case SET_EDITOR_DIM: {
      return { ...state, editorDim: action.dim };
    }
    case RENDER_CANVAS_FROM_STORE: {
      return {
        ...state,
        renderPage: action.page,
        renderCanvas: new Date().getTime(),
      };
    }
    case SET_SIDEPANEL_OPENED: {
      return {
        ...state,
        sidePanelOpened: action.openclose,
        colorPickerIsOpen: action.openclose,
      };
    }
    case COLOR_PICKER_OPEN: {
      return { ...state, colorPickerIsOpen: action.openclose };
    }
    case SET_VIEWPRINTS_FORCE_CLOSED: {
      return { ...state, viewPrintsForceClosed: action.close };
    }
    case SET_BOTTOMPANEL_OPENED: {
      return { ...state, bottomPanelOpened: action.openclose };
    }
    case SET_BOTTOMPANEL_EXPANDED: {
      return { ...state, bottomPanelExpanded: action.expanded };
    }
    case SET_CAN_NAVIGATE: {
      return {
        ...state,
        canGoForward: action.canGoForward,
        canGoBack: action.canGoBack,
        forwardLocked: action.forwardLocked,
        backLocked: action.backLocked,
      };
    }
    case SET_IS_RESIZING: {
      return { ...state, isResizing: action.value };
    }
    case ENTER_SHARE_VIEW: {
      return { ...state, shareView: true };
    }
    case ENTER_EDITINGVIEW_MODE: {
      return {
        ...state,
        editingView: true,
        previewMode: false,
        gridView: false,
        zoomLevel: 0,
        sidePanelOpened: true,
        colorPickerIsOpen: false,
      };
    }
    case EXIT_EDITINGVIEW_MODE: {
      return {
        ...state,
        editingView: false,
        previewMode: false,
        gridView: true,
        sidePanelOpened: false,
        colorPickerIsOpen: false,
      };
    }
    case ENTER_GRID_VIEW: {
      return {
        ...state,
        editingView: false,
        previewMode: false,
        gridView: true,
        sidePanelOpened: false,
        colorPickerIsOpen: false,
      };
    }
    case EXIT_GRID_VIEW: {
      return {
        ...state,
        editingView: true,
        previewMode: false,
        gridView: false,
        sidePanelOpened: true,
      };
    }
    case ENTER_PREVIEW_MODE: {
      return {
        ...state,
        editingView: false,
        previewMode: true,
        gridView: false,
        sidePanelOpened: false,
        colorPickerIsOpen: false,
      };
    }
    case EXIT_PREVIEW_MODE: {
      return {
        ...state,
        editingView: true,
        previewMode: false,
        gridView: false,
        sidePanelOpened: true,
        colorPickerIsOpen: false,
      };
    }
    case SWITCH_PRINTS_VIEW: {
      return {
        ...state,
        printsMode: action.mode,
        previewMode: false,
        sidePanelOpened: true,
      };
    }
    case PAGE_ITEM_SELECTION: {
      if (state.editorTab === TAB_EDIT_PHOTO && action.pageItems.length === 0) {
        // If we're on the edit photo tab, and we unselect the photo, switch to the photos tab
        return { ...state, editorTab: TAB_PHOTOS };
      }
      return state;
    }
  }
  return state;
}

/**
 *  actions
 */

export function setMobile(isMobile) {
  return {
    type: SET_MOBILE,
    isMobile,
  };
}

export function setLeftPageZoom(value) {
  return {
    type: SET_LEFT_PAGE_ZOOM,
    value,
  };
}

function printsView(mode) {
  return {
    type: SWITCH_PRINTS_VIEW,
    mode,
  };
}

export function toggleImageManagement(pickPhoto = false, postAction = null) {
  return {
    type: TOGGLE_IMAGE_MANAGMENT,
    pickPhoto,
    postAction,
  };
}

export function keepSelectedTab(action) {
  return { ...action, keepSelectedTab: true };
}
export function setSelectedTab(selectedTab, event = null) {
  if (event != null) logEvent('Side panel', 'Opened', selectedTab, 0);
  return {
    type: SET_SELECTED_TAB,
    selectedTab,
  };
}

export function clearSelectedTab() {
  return { type: CLEAR_SELECTED_TAB };
}

export function setBottomTab(selectedTab) {
  return {
    type: SET_BOTTOM_TAB,
    selectedTab,
  };
}

export function togglePhotosModal(modalAutoOpened = false) {
  return {
    type: TOGGLE_PHOTOS_MODAL,
    modalAutoOpened,
  };
}
export function toggleMobilePhotosUpload() {
  return {
    type: TOGGLE_MOBILE_PHOTOS_UPLOAD,
  };
}
export function togglePhotoViewModal(modalPhotoViewOpened = false) {
  return {
    type: TOGGLE_PHOTO_VIEW_MODAL,
    modalPhotoViewOpened,
  };
}

export function toggleAutoFillPromptModal(isAutoPopulate = false) {
  return {
    type: TOGGLE_AUTO_FILL_PROMPT_MODAL,
    isAutoPopulate,
  };
}

export function closeAutoFillPromptModal() {
  return {
    type: CLOSE_AUTO_FILL_PROMPT_MODAL,
  };
}

export function toggleAutoFillWaitModal() {
  return {
    type: TOGGLE_AUTO_FILL_WAIT_MODAL,
  };
}

export function setZoomLevel(zoomLevel) {
  logEvent(
    'Toolbar',
    'Zoom',
    zoomLevel == 0
      ? 'Fit page'
      : zoomLevel == 1
        ? 'Fit width'
        : zoomLevel == 2
          ? 'Fit height'
          : zoomLevel,
    0,
  );
  return {
    type: SET_ZOOM_LEVEL,
    zoomLevel,
  };
}

export function setEditorDim(dim) {
  return {
    type: SET_EDITOR_DIM,
    dim,
  };
}
export function renderCanvasFromStore(pageID) {
  return {
    type: RENDER_CANVAS_FROM_STORE,
    page: pageID,
  };
}

export function setSidePanelOpened(openclose) {
  if (!openclose) logEvent('Side panel', 'Closed', '', 0);
  return {
    type: SET_SIDEPANEL_OPENED,
    openclose,
  };
}

export function setColorPickerOpened(openclose) {
  return {
    type: COLOR_PICKER_OPEN,
    openclose,
  };
}

export function setViewPrintsForceClosed(close) {
  if (close) logEvent('View Prints', 'Closed', '', 0);
  return {
    type: SET_VIEWPRINTS_FORCE_CLOSED,
    close,
  };
}

export function setBottomPanelOpened(openclose) {
  if (!openclose) logEvent('Bottom panel', 'Closed', '', 0);
  else logEvent('Bottom panel', 'Opened', '', 0);
  return {
    type: SET_BOTTOMPANEL_OPENED,
    openclose,
  };
}

export function setBottomPanelExpanded(expanded) {
  return {
    type: SET_BOTTOMPANEL_EXPANDED,
    expanded,
  };
}

export function setCanNavigate(
  canGoForward,
  canGoBack,
  forwardLocked = false,
  backLocked = false,
) {
  return {
    type: SET_CAN_NAVIGATE,
    canGoForward,
    canGoBack,
    forwardLocked,
    backLocked,
  };
}

export function setIsResizing(value) {
  return {
    type: SET_IS_RESIZING,
    value,
  };
}

export function enterEditingView() {
  return {
    type: ENTER_EDITINGVIEW_MODE,
  };
}

export function exitEditingView() {
  return {
    type: EXIT_EDITINGVIEW_MODE,
  };
}

export function enterShareView() {
  return {
    type: ENTER_SHARE_VIEW,
  };
}

export function enterPreviewMode() {
  return {
    type: ENTER_PREVIEW_MODE,
  };
}

export function exitPreviewMode() {
  return {
    type: EXIT_PREVIEW_MODE,
  };
}

export function enterGridView() {
  return {
    type: ENTER_GRID_VIEW,
  };
}

export function exitGridView() {
  return {
    type: EXIT_GRID_VIEW,
  };
}

export function setNavigation() {
  return {
    type: SET_NAVIGATION,
  };
}

//tab helper
export function getDefaultTab(productId) {
  switch (productId) {
    case PicabooConstants.PRODUCT_TYPES.CANVAS:
      return TAB_FRAME_COLOR;
    case PicabooConstants.PRODUCT_TYPES.CARD:
      return TAB_DESIGNS;
    // case PicabooConstants.PRODUCT_TYPES.BOOK:
    //     return TAB_CROP_PREVIEW;
    case PicabooConstants.PRODUCT_TYPES.PRINTS:
      return TAB_PAGES;
    default:
      if (isMobile()) {
        return TAB_PHOTOS;
      }
    //return TAB_BACKGROUND;
  }
}

export function sidePanelOpenedSelector(state) {
  return state.navigation.sidePanelOpened;
}

export function selectedEditorTabSelector(state) {
  return state.navigation.editorTab;
}

/**
 * Sagas
 */
function* setProjectSaga(action) {
  const permissions = action.project.project.permissions;
  let sections = action.project.sections;
  let previewMode = yield select(Selectors.previewModeSelector);

  if (sections === undefined) {
    sections = (yield select(Selectors.projectSectionsSelector)).toJS();
  }

  const projectPK = action.project.project.projectPK;
  const currentSectionID = action.project.currentSection;
  const currentSection = sections[currentSectionID];
  const currentPages = action.project.pages;

  const canGo = canNavigate(
    sections,
    currentSectionID,
    currentSection,
    currentPages,
    permissions,
    projectPK,
    previewMode,
  );

  yield put(
    setCanNavigate(
      canGo.canGoForward,
      canGo.canGoBack,
      canGo.forwardLocked,
      canGo.backLocked,
    ),
  );

  const currentTab = yield select((state) => state.navigation.editorTab);
  //When moving to/from the cover we may need to set the selected tab
  if (!action.keepSelectedTab) {
    if (!currentTab && !isMobile()) {
      yield put(setSelectedTab(getDefaultTab(action.project.project.type)));
    }
  }

  let layouts = yield select(Selectors.layoutSelector);
  let obj = layouts.layouts;
  if (obj.length <= 0) {
    if (SUPPORTS_LAYOUTS.indexOf(action.project.project.type) > -1) {
      yield put(getCurrentLayouts());
      yield put(getSavedLayouts());
    }
  }

  // 2025-07-31 This one-time warning (per project) is for customers with in-progress books
  // that are affected by removal of our automatic 'spineShift' functionality.
  // We should probably just remove this after a year or so.

  const isShareView = yield select(Selectors.shareViewSelector);
  if (!isShareView) {
    const userPrefs = yield select(Selectors.userPrefSelector);
    const spineShiftWarningSeen =
      userPrefs.get(
        PicabooConstants.PREFERENCE_NAME.SPINE_SHIFT_WARNING_SEEN,
      ) || [];

    if (!spineShiftWarningSeen.includes(projectPK)) {
      const productInfo = yield select(Selectors.projectProductInfoSelector);
      let spineSizes = productInfo.get('spineSizes') || [];
      if (isList(spineSizes)) {
        spineSizes = spineSizes.toJS();
      }

      if (spineSizes.length > 0) {
        yield put(
          updateUserPreference(
            PicabooConstants.PREFERENCE_NAME.SPINE_SHIFT_WARNING_SEEN,
            spineShiftWarningSeen.concat(projectPK),
          ),
        );

        const numPages = action.project.project.numPages;
        const style = yield select(Selectors.projectStyleSelector);
        const isTradebookDefaultPageCount =
          style == PicabooConstants.PRODUCT_SUBTYPE.TRADEBOOK &&
          numPages === DEFAULT_TRADEBOOK_PAGE_COUNT;
        if (numPages >= spineSizes[0].pages && !isTradebookDefaultPageCount) {
          yield put(
            showSuccessModal(
              'SPINESHIFT.OneTimeWarning_Title',
              'SPINESHIFT.OneTimeWarning_Text',
              'MODAL.OK',
            ),
          );
        }
      }
    }
  }
}

function* setNavigationSaga(action) {
  const permissions = yield select(Selectors.permissionsSelector);
  const sections = (yield select(Selectors.projectSectionsSelector)).toJS();
  const previewMode = yield select(Selectors.previewModeSelector);
  const currentSectionID = yield select(Selectors.sectionIdSelector);
  const currentSection = sections[currentSectionID];
  const currentPages = yield select(Selectors.pagesSelector);
  const projectPK = yield select(Selectors.projectPKSelector);

  const canGo = canNavigate(
    sections,
    currentSectionID,
    currentSection,
    currentPages.toJS(),
    permissions.toJS(),
    projectPK,
    previewMode,
  );

  yield put(
    setCanNavigate(
      canGo.canGoForward,
      canGo.canGoBack,
      canGo.forwardLocked,
      canGo.backLocked,
    ),
  );
}

function* toggleImageManagementSaga(action) {
  const navigation = yield select(Selectors.navigationSelector);
  if (
    navigation.showImageManagement === false &&
    navigation.showImageManagementPostAction
  ) {
    const images = yield select(Selectors.projectImagesSelector);
    if (images.size > 0) {
      yield put(navigation.showImageManagementPostAction);
    } else {
      yield put(setBottomTab(TAB_PAGES));
      yield put(setBottomPanelExpanded(true));
    }

    yield put({ type: CLEAR_IMAGE_MANAGEMENT_POST_ACTION });
  } else {
    yield put(setBottomTab(TAB_PHOTOS));
  }
}

function* toggleSidePanelSaga() {
  yield put(setColorPickerOpened(false));
  yield put(renderCanvasFromStore());
}

function* tabSelectedSaga(action) {
  const deselectItemsTabs = [
    TAB_PHOTOS,
    TAB_WARNINGS,
    TAB_LAYOUTS,
    TAB_OPTIONS,
    TAB_SETTINGS,
    TAB_DESIGNER,
  ];
  if (deselectItemsTabs.includes(action.selectedTab)) {
    yield put(selectPageItems([]));
  }
}

function* setupSagas() {
  yield takeLatest([SET_PROJECT, SET_PROJECT_UNDOABLE], setProjectSaga);
  yield takeLatest([SET_NAVIGATION], setNavigationSaga);
  yield takeLatest([TOGGLE_IMAGE_MANAGMENT], toggleImageManagementSaga);
  yield takeLatest(SET_SIDEPANEL_OPENED, toggleSidePanelSaga);
  yield takeLatest(SET_SELECTED_TAB, tabSelectedSaga);
}

export default {
  reducer: rootReducer,
  saga: setupSagas,
};
